import Grid from '@mui/material/Grid';

// Material Dashboard 2 PRO React TS components
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDAvatar from 'components/MDAvatar';

// Images
import burceMars from 'assets/images/bruce-mars.jpg';
import { useUser } from 'context/user';

function Header(): JSX.Element {
  const { user } = useUser();

  return (
    <MDBox p={2}>
      <Grid container spacing={3} alignItems="center">
        <Grid item>
          <MDAvatar src={burceMars} alt="profile-image" size="xl" shadow="sm" />
        </Grid>
        <Grid item>
          <MDBox height="100%" mt={0.5} lineHeight={1}>
            <MDTypography variant="h5" fontWeight="medium">
              {user.name}
            </MDTypography>
          </MDBox>
        </Grid>
      </Grid>
    </MDBox>
  );
}

export default Header;
